// @vue/component
const canReachApi = {
	data() {
		return {
			canReachApi: navigator.onLine,
		}
	},
	async mounted() {
		window.addEventListener('online', this.updateCanReachApi)
		window.addEventListener('offline', this.updateCanReachApi)
	},
	unmounted() {
		window.removeEventListener('online', this.updateCanReachApi)
		window.removeEventListener('offline', this.updateCanReachApi)
	},
	methods: {
		async updateCanReachApi() {
			if (!navigator.onLine) return (this.canReachApi = false)
			try {
				await this.$api.get('/')
				this.canReachApi = true
			} catch (error) {
				this.canReachApi = false
			}
		},
	},
}

export default canReachApi
